import React from 'react';
import FilterOptions from './FilterOptions';
import TransActionItem from './TransActionItem';
import Loading from './ui/Loading';

function Transactions({ transactions, isLoading, isError, error }) {
    let content = null;

    if (isLoading) {
        content = <Loading />;
    }
    if (isError) {
        content = <p>{error}</p>;
    }
    if (!isLoading && !isError && transactions.length === 0) {
        content = <p>Transaction not found</p>;
    }
    if (!isLoading && !isError && transactions.length > 0) {
        content = transactions.map((transaction) => (
            <TransActionItem key={transaction.id} transaction={transaction} />
        ));
    }

    console.log(transactions);

    return (
        <>
            <p className="second_heading">Your Transactions:</p>
            <FilterOptions />
            <div className="conatiner_of_list_of_transactions">
                <ul>{content}</ul>
            </div>
        </>
    );
}

export default Transactions;
